import { LanguageService } from './../services/language.service';
import { TranslateService, TranslatePipe } from '@ngx-translate/core';
import { DropDownConstantsFactory } from './../shared/syncfusion/dropdown-constants-factory';
import { Component, Input, OnInit, OnDestroy, ViewChild, AfterViewChecked, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
import { FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { Role, UserAccountClient, UserInfoDTO } from '../models/models.swagger.generated';
import { AuthService } from '../services/auth.service';
import { Subscription } from 'rxjs';
import { TooltipComponent, TooltipModule } from '@syncfusion/ej2-angular-popups';
import { startWith } from 'rxjs/operators';
import { SpinnerService } from '../spinner/spinner.service';
import { UserEditFormType } from './user-edit-form-type';
import { YesNoGroupButtonComponent } from '../shared/yes-no-group-button/yes-no-group-button.component';
import { ButtonGroupComponent } from '../shared/button-group/button-group.component';
import { DatePickerModule } from '@syncfusion/ej2-angular-calendars';
import { DropDownListModule } from '@syncfusion/ej2-angular-dropdowns';
import { NgClass, DatePipe } from '@angular/common';
import { AppErrorMessagesComponent } from '../error-messages/app-error-messages.component';
import { UserType } from '../models/user-management-data';
import { ClientAutocompleteComponent } from "../shared/client-autocomplete/client-autocomplete.component";

@Component({
    selector: 'app-user-edit-form',
    templateUrl: './user-edit-form.component.html',
    styleUrls: ['./user-edit-form.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [ReactiveFormsModule, AppErrorMessagesComponent, DropDownListModule, NgClass, TooltipModule, DatePickerModule, ButtonGroupComponent, YesNoGroupButtonComponent, DatePipe, TranslatePipe, ClientAutocompleteComponent]
})
export class UserEditFormComponent implements OnInit, AfterViewChecked, OnDestroy {
  @Input({required: true}) public userEditForm!: FormGroup<UserEditFormType>;

  @ViewChild('validUntilToolTip') private validUntilToolTip: TooltipComponent | null = null;

  public dropdownSettings = DropDownConstantsFactory.createStandardClientDropdownSettings();
  public languageDropdownSettings = {text: 'value', value: 'key'};
  public Role = Role;
  public isAdd: boolean = true;
  public languageDropDowItems: any[] = [];
  public hiddenRoles: Role[] = [Role.None, Role.Admin, Role.WebUser, Role.MobileUser];

  public get formFields() {
    return this.userEditForm.controls;
  }

  public get isMobileUser(): boolean {
    return this.userEditForm.value.userType === UserType.Mobile;
  }

  public get isLoggedInUser(): boolean {
    return this.userEditForm.value.userId === this.authService.getUserInfo()?.userId;
  }

  private subscriptions = new Subscription();

  constructor(
    public authService: AuthService,
    private userAccountClient: UserAccountClient,
    private languageService: LanguageService,
    private translate: TranslateService,
    private cdr: ChangeDetectorRef,
    private spinnerService: SpinnerService) {
  }

  public ngOnInit() {
    this.isAdd = !this.userEditForm.value.userId;

    this.initializeForms();
    if (this.authService.isUserAdmin()) {
      this.hiddenRoles = [Role.None, Role.MobileUser];
    } else {
      this.hiddenRoles = [Role.None, Role.Admin, Role.MobileUser];
    }

    this.subscriptions.add(this.userEditForm.controls.role.valueChanges.subscribe((v: Role | null) => {
      if (v === Role.Admin) {
        if (v === Role.Admin) {
          this.userEditForm.controls.client.reset();
        }
        this.userEditForm.controls.client.setValidators([]);
        this.userEditForm.controls.client.disable({emitEvent: false});
      } else {
        this.userEditForm.controls.client.setValidators([Validators.required]);
        this.userEditForm.controls.client.enable({emitEvent: false});
      }
      this.userEditForm.controls.client.updateValueAndValidity({emitEvent: false});
    }));
  }

  public ngAfterViewChecked(): void {
    this.cdr.detectChanges();
  }

  public ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  public hideClient() {
    return this.authService.getUserInfo()?.clientId || this.isLoggedInUser;
  }

  public generateCode() {
    if (!this.userEditForm.value.userId) {
      return;
    }
    this.spinnerService.show();
    this.userAccountClient.regenerateAccessCode(this.userEditForm.value.userId).subscribe((userInfoDTO: UserInfoDTO) => {
      this.userEditForm.patchValue({
        accessCodeValidUntil: userInfoDTO.accessCodeValidUntil?.toJSDate() ?? null,
        accessCodeGeneratedOn: userInfoDTO.accessCodeGeneratedOn ?? null,
      });
      this.validUntilToolTip?.open();
      setTimeout(() => {
        this.validUntilToolTip?.close();
      }, 5000);
      this.spinnerService.hide();
    });
  }

  private initializeForms(): void {
    this.subscriptions.add(this.translate.onLangChange.pipe(startWith({})).subscribe(v => {
      this.languageDropDowItems = this.languageService.getLanguages()
      .map(l => ({key: l, value: this.translate.instant('i18n.base.shared.Language.' + l)}));
    }));
  }
}


